/**
 * Escape regex characters.
 * @param {string} string
 */
export function escapeRegExp(string) {
  // eslint-disable-next-line
  return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
}

/**
 * Convert String to Boolean.
 * @param {string} value
 * @param {*} def
 * @returns {*}
 */
export function toBoolean(value, def = null) {
  if ([true, 1, '1', 'true'].indexOf(value) >= 0) {
    return true;
  } else if ([false, 0, '0', 'false'].indexOf(value) >= 0) {
    return false;
  }

  return def;
}

/**
 * Convert String to Number.
 * @param {string} value
 * @param {*} def
 * @returns {*}
 */
export function toNumber(value, def = null) {
  if (isNaN(Number(value))) {
    return def;
  }

  return Number(value);
}

export function hideEmail(email) {
  const [name, domain] = email.split('@');

  const [, extension] = domain.split('.');

  return `${name.substring(0, 1)}***@${domain.substring(0, 1)}***.${extension}`;
}

export function firstLetterToUpper(string) {
  return string.charAt(0)
    .toUpperCase() + string.slice(1);
}

// convert language special characters to latin
export function latinize(string) {
  return string.normalize('NFD')
    .replace(/[\u0300-\u036f]/gu, '');
}
